import { Device } from '@capacitor/device';
import platform from 'platform';
import { ClientJS } from 'clientjs';
import { getEncryptedDeviceIdForHeaders } from './ecies-encrypt';
export default {
    data() {
        return {
            WLdeviceId: null,
            showOtpModal: false,
            otp: null,
            deviceList: [],
            showUnsanctionedDeviceModal: false,
            inValidOtp: false,
            clientDevice: new ClientJS()
        }
    },
    created () {
        if(!this.getDeviceId()) {
            this.WLdeviceId = this.setDeviceId();
        }
        this.getDeviceDetails();
        // console.log('is safari?', this.clientDevice.isSafari());
        console.log('clientJs: ', this.clientDevice.getFingerprint());
    },
    methods: {
        compareAccount(email = null) {
            // const keyedEmail = process.env.VUE_APP_PRIVATE_ACCT_1
            // const isMatch = email === keyedEmail
            // console.log('comparison: ', `${email}===${keyedEmail}`)
            // if (isMatch) {
            //     // this.compareKey()
            //     this.compareAgainstMultiKeys(email)
            // }
            if(email){
                console.log('running compareAgainstMultiKeys against', email)
                this.compareAgainstMultiKeys(email)
            }
        },
        compareKey() {
            const key = process.env.VUE_APP_PRIVATE_KEY_1
            const localkey = this.getDeviceId()
            const isMatch = key === localkey
            console.log('key/localkey comparison: ', `${key}===${localkey}`)
            if (!isMatch) {
                localStorage.setItem('WLdeviceId', key);
                this.WLdeviceId = key
            }
        },
        compareAgainstMultiKeys(email) {
            let keyRecord = null;
            const keyList = JSON.parse(process.env.VUE_APP_MULTI_KEY);
            keyRecord = keyList.find(key => (key.email).toLowerCase() === (email).toLowerCase());
            if (keyRecord) {
                console.log('Setting key locally');
                localStorage.setItem('WLdeviceId', keyRecord.key);
                this.WLdeviceId = keyRecord.key
            }
        },
        getDeviceId() {
            this.WLdeviceId = localStorage.getItem('WLdeviceId') || null
            return this.WLdeviceId;
        },
        setDeviceId() {
            const deviceId = this.clientDevice.getFingerprint()
            localStorage.setItem('WLdeviceId', deviceId);
            return deviceId;
        },
        async getEncryptedDeviceId(deviceId) {
            const id = deviceId ?? this.WLdeviceId ?? this.getDeviceId() ?? this.setDeviceId();
            return getEncryptedDeviceIdForHeaders(id);
        },
        actBasedOnResponseCode(response) {
            if(response.code === "400") {
                // eventBus.$emit('trac-alert', { message: response.message });
                return false;
            } else if(response.code === 'DEV001') {
                this.showOtpModal = true;
                return false;
            } else if(response.code === "200") {
                return true;
            }
        },
        isSanctioned(response = null) {
            if(response && response.error === 'Device not recognized - Logout and login again to add device') {
                this.showUnsanctionedDeviceModal = true;
                return false;
            }
        },
        async generateDeviceDetails(options = {email, otp}) {
            const deviceInfo = await this.getDeviceDetails()
            const payload = {
                email: options.email,
                code: options.otp,
                device: {
                    deviceId: this.WLdeviceId,
                    deviceModel: deviceInfo.model,
                    browser: {
                        name: platform.name,
                        version: deviceInfo.webViewVersion
                    },
                    whitelisted: true,
                    deviceType: 'browser'
                }
            }
            // console.log('payload', payload);
            return payload
        },
        async getDeviceDetails() {
            const info = await Device.getInfo();
            // const deviceId = await Device.getId();
            // const platformInfo = platform
          
            // console.log('device Details', info);
            // console.log('deviceId', deviceId);
            // console.log('platform', platformInfo);
            return info
        },    
    },
    computed: {
        otpIsValid() {
            return this.otp && this.otp.length === 4;
        },
        computerDevices() {
            return this.deviceList.filter(device => device.deviceType === 'browser');
        },
        mobileDevices() {
            return this.deviceList.filter(device => device.deviceType === 'Mobile');
        },
        terminalDevices() {
            return this.deviceList.filter(device => device.deviceType === 'Terminal');
        },
        computerListPlural() {
            return this.computerDevices.length > 1;
        },
        mobileListPlural() {
            return this.mobileDevices.length > 1;
        },
        terminalListPlural() {
            return this.mobileDevices.length > 1;
        },
    },
}
